/**
 * Join location parts (neighborhood, city, state) with ", ",
 * skipping any empty or missing segments so no stray commas render.
 */
export function formatLocation(...parts: (string | null | undefined)[]): string {
  return parts
    .map((part) => (part ?? "").trim())
    .filter((part) => part.length > 0)
    .join(", ");
}
